import React from 'react'

const Flexbox_Coding_Pratice_4 = () => {
  return (
    <div>
      <h1>Flexbox Coding Practice 4</h1>
    </div>
  )
}

export default Flexbox_Coding_Pratice_4
